import ServiceRestApi from "./service-rest-api";

class FolderService {

    cacheUtility = {};

    getFolderItems = () => {
        return ServiceRestApi.get("/api/folders");
    }

    getFolderInterventions = (folderId) => {
        return ServiceRestApi.get(`/api/interventions?view=folder&folder-id=${folderId}`)
    }

    getLazyFolderInterventions = (folderId, pageIndex, pageSize = 30, filterQuery = ``, sortBy) => {
        sortBy = sortBy ? sortBy : "DESC";
        return ServiceRestApi.get(`/api/interventions?view=folder&folder-id=${folderId}&sort=${sortBy}&page-size=${pageSize}&page-index=${pageIndex}&${filterQuery}`)
    }

    getFolderResources = () => {
        let suffix = `/api/folder-prerequisites`;
        if (!this.cacheUtility[suffix]) this.cacheUtility[suffix] = ServiceRestApi.get(suffix);
        return this.cacheUtility[suffix];
    }

    getLazyFolder = (folderId) => {
        return ServiceRestApi.get(`/api/folder?folder-id=${folderId}`);
    }

    postFolder = (payload) => {
        return ServiceRestApi.post(`/api/folder`, payload);
    }

    deleteFolder = ({ folderId }) => {
        return ServiceRestApi.delete(`/api/folder?folder-id=${folderId}`)
    }
    
}
export default new FolderService();